import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st5{fill:none;stroke:{{strokeColor}};stroke-width:2;stroke-miterlimit:10;}
    .st9{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
    .st10{fill:none;stroke:{{strokeColor}};stroke-width:0.5;stroke-miterlimit:10;}
  </style>
  <g>
    <rect x="2.4" y="6" class="st9" width="25.2" height="18"/>
    <rect x="11" y="12.5" transform="matrix(-1.742238e-05 1 -1 -1.742238e-05 35.0187 -4.9804)" class="st10" width="17.9" height="5.1"/>
    <rect x="5.9" y="12.5" transform="matrix(-1.742238e-05 1 -1 -1.742238e-05 29.8973 0.1408)" class="st10" width="17.9" height="5.1"/>
    <line class="st5" x1="2" y1="7.5" x2="28" y2="7.5"/>
    <line class="st10" x1="2" y1="11.6" x2="28" y2="11.6"/>
    <line class="st10" x1="2" y1="14.8" x2="28" y2="14.8"/>
    <line class="st10" x1="2" y1="18.1" x2="28" y2="18.1"/>
    <line class="st10" x1="2" y1="21.3" x2="28" y2="21.3"/>
  </g>
</svg>
`

export const table: ComponentGroup = {
  name: 'table',
  description: 'a group of various tables',
  icon,
  templates: []
}
